"use client";

import Icon from "@/components/icons";
import { IconTypes } from "@/components/icons/types";
import Link from "next/link";
import Image from "next/image";
import { useFooterMessages } from "@/i18n/hooks/useFooterMessages";

interface SocialLinkProps {
  source: string;
  icon: string;
  href: string;
  arialabel: string;
}

export default function FooterHeader() {
  const m = useFooterMessages();

  const socialLinks: SocialLinkProps[] = [
    {
      source: "facebook",
      icon: "facebook-circle",
      href: "https://www.facebook.com/edx/",
      arialabel: m.socialFacebook,
    },
    {
      source: "x",
      icon: "x",
      href: "https://x.com/edXOnline",
      arialabel: m.socialX,
    },
    {
      source: "linkedin",
      icon: "linkedin-circle",
      href: "https://www.linkedin.com/school/edx/",
      arialabel: m.socialLinkedIn,
    },
    {
      source: "reddit",
      icon: "reddit",
      href: "https://www.reddit.com/r/edX/",
      arialabel: m.socialReddit,
    },
  ];

  return (
    <div className="flex flex-wrap justify-between mb-6 w-full">
      <Link href="/" className="mb-6">
        <Image
          src="/trademark-logos/edx-by-2u-white.svg"
          alt={m.logoAlt}
          title={m.logoTitle}
          width={127}
          height={67}
        />
      </Link>
      <div>
        <div className="mb-4 justify-center flex flex-row">
          {socialLinks.map((socialLink, index) => {
            return (
              <div key={index} className="mx-2 flex flex-col">
                <a
                  href={socialLink.href}
                  target="_blank"
                  role="button"
                  aria-label={socialLink.arialabel}
                >
                  <div className="flex text-primary bg-white border border-solid border-primary h-12 w-12 items-center justify-center rounded-full">
                    <Icon type={socialLink.icon as IconTypes} />
                  </div>
                </a>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}
